import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastComponent } from '../toast/toast.component';

@Component({
  selector: 'base',
  template: ''
})
export class BaseComponent {

  constructor(public snackBar: MatSnackBar) { }

  showSuccess(message: string) {
    this.snackBar.openFromComponent(ToastComponent, {
      data: message,
      panelClass: ['snackbar-success']
    });
  }

  showError(error: any, message: string) {
    this.snackBar.openFromComponent(ToastComponent, {
      data: error && error.error && typeof error.error === "string" ? error.error : message,
      panelClass: ['snackbar-error']
    });
  }

  empty(items: any[]) {
    return !items || !items.length;
  }

  clone(item: any) {
    return JSON.parse(JSON.stringify(item));
  }

  dummy() { }
}